import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { WidgetHeaderDetailMaterialComponent } from './components/widget-header-detail-material/widget-header-detail-material.component';
import { WidgetWrapperComponent } from './components/widget-wrapper/widget-wrapper.component';
import { WidgetWrapperHeadedComponent } from './components/widget-wrapper-headed/widget-wrapper-headed.component';
import { WidgetBasicComponent } from './components/widget-basic/widget-basic.component';
import { WidgetRequestComponent } from './components/widget-request/widget-request.component';
import { Common2Module } from 'projects/common/src/app/app.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationInterceptorService } from 'projects/authentication/src/app/services/interceptors';
import { authenticationServiceProvider, communicationServiceProvider } from 'src/app/services/providers';
import { WidgetConfigurationModalComponent } from './components/widget-configuration-modal/widget-configuration-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    WidgetHeaderDetailMaterialComponent,
    WidgetWrapperComponent,
    WidgetWrapperHeadedComponent,
    WidgetBasicComponent,
    WidgetRequestComponent,
    WidgetConfigurationModalComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CoreModule,
    Common2Module.forRoot()
  ],
  exports: [
    WidgetHeaderDetailMaterialComponent,
    WidgetWrapperComponent,
    WidgetWrapperHeadedComponent,
    WidgetBasicComponent,
    WidgetRequestComponent,
    WidgetConfigurationModalComponent
  ],
  providers: [
    communicationServiceProvider,
    authenticationServiceProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptorService,
      multi: true
    },
  ]
})
export class WidgetModule { }
